import Router from 'next/router';

const pop = () => {
    Router.back();
};

export default pop;
